import { render, staticRenderFns } from "./Fullmakt.vue?vue&type=template&id=3b0cd996&scoped=true&"
import script from "./Fullmakt.vue?vue&type=script&lang=js&"
export * from "./Fullmakt.vue?vue&type=script&lang=js&"
import style0 from "./Fullmakt.vue?vue&type=style&index=0&id=3b0cd996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0cd996",
  null
  
)

export default component.exports